import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Search, FileText, QrCode, ShieldCheck, LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/app", end: true, label: "Panoramica", icon: LayoutGrid, testid: "dashboard-tab-overview" },
  { to: "/app/ricerca", label: "Ricerca Anagrafica", icon: Search, testid: "dashboard-tab-search" },
  { to: "/app/segnalazioni", label: "Segnalazioni Sfratto", icon: FileText, testid: "dashboard-tab-reports" },
  { to: "/app/passaporto", label: "Passaporto Inquilino", icon: QrCode, testid: "dashboard-tab-passport" },
];
const ADMIN_NAV = { to: "/app/verifica", label: "Verifica Segnalazioni", icon: ShieldCheck, testid: "dashboard-tab-admin" };

const linkCls = ({ isActive }) =>
  `flex shrink-0 items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm font-semibold ${isActive ? "bg-[#1e3a8a] text-white" : "text-slate-600 hover:bg-slate-100 hover:text-[#0f172a]"}`;

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = user.role === "admin" ? [...NAV, ADMIN_NAV] : NAV;

  const doLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] lg:flex">
      <aside className="border-b border-slate-200 bg-white lg:fixed lg:inset-y-0 lg:flex lg:w-72 lg:flex-col lg:border-b-0 lg:border-r">
        <div className="flex items-center justify-between px-5 py-5"><Logo to="/app" /></div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-1 lg:flex-col lg:pb-0">
          {items.map(({ to, end, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} end={end} className={linkCls} data-testid={testid} style={{ transition: "background-color 160ms, color 160ms" }}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden border-t border-slate-200 p-4 lg:block">
          <div className="flex items-center gap-3">
            {user.picture ? <img src={user.picture} alt="" className="h-9 w-9 rounded-full" /> : (
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#dbeafe] text-sm font-bold text-[#1e3a8a]">{user.name?.[0]?.toUpperCase()}</span>
            )}
            <div className="min-w-0 flex-1">
              <p data-testid="dashboard-user-name" className="truncate text-sm font-semibold text-[#0f172a]">{user.name}</p>
              <p className="truncate text-xs text-slate-500">{user.email}</p>
            </div>
          </div>
          <button data-testid="button-logout" onClick={doLogout} className="btn-ghost mt-4 w-full"><LogOut className="h-4 w-4" />Esci</button>
        </div>
      </aside>
      <main className="flex-1 px-4 py-8 sm:px-8 lg:ml-72 lg:px-12 lg:py-12">
        <div className="mb-6 flex justify-end lg:hidden">
          <button data-testid="button-logout-mobile" onClick={doLogout} className="btn-ghost"><LogOut className="h-4 w-4" />Esci</button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
